import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { getRotatedFootprint } from "3d/pallet";
import { objectPosition } from "3d/constants/common";
/*
 * A top view of what a pattern actually does to the current pallet, drawn from
 * the same placements the scene is laid out from. Deriving the icon rather than
 * shipping five fixed pictures means it always shows the real arrangement for
 * the box size at hand — including how many boxes fit and where the gaps fall.
 *
 * Boxes are drawn in `currentColor`, so the button around it decides how a
 * selected and an unselected preset look.
 */
export var PalletPatternIcon = function (_a) {
    var pallet = _a.pallet, boxFootprint = _a.boxFootprint, placements = _a.placements, _b = _a.width, width = _b === void 0 ? 44 : _b;
    var height = width * (pallet.width / pallet.length);
    // A hairline of pallet showing between boxes, so a block pattern doesn't read
    // as one solid rectangle.
    var gap = Math.min(pallet.length, pallet.width) * 0.03;
    return (_jsxs("svg", { width: width, height: height, viewBox: "0 0 ".concat(pallet.length, " ").concat(pallet.width), preserveAspectRatio: "xMidYMid meet", "aria-hidden": true, children: [_jsx("rect", { x: 0, y: 0, width: pallet.length, height: pallet.width, fill: "none", stroke: "currentColor", strokeOpacity: 0.4, strokeWidth: gap }), placements.map(function (placement, index) {
                var _a;
                var footprint = getRotatedFootprint((_a = placement.footprint) !== null && _a !== void 0 ? _a : boxFootprint, placement.rotation);
                /* World XZ → icon XY: the pallet is centred on `objectPosition`, the
                 * icon's origin is its top-left corner. */
                var x = placement.position.x - objectPosition.x + pallet.length / 2;
                var y = placement.position.z - objectPosition.z + pallet.width / 2;
                return (_jsx("rect", { x: x - footprint.x / 2 + gap / 2, y: y - footprint.z / 2 + gap / 2, width: Math.max(0, footprint.x - gap), height: Math.max(0, footprint.z - gap), fill: "currentColor" }, index));
            })] }));
};
